import { ReactComponent as IconFullStar } from "../../../../layout/others/icon_star_active_yellow.svg";
import { ReactComponent as IconEmptyStar } from "../../../../layout/others/icon_star_idle_yellow.svg";
import { ReactComponent as IconHalfStar } from "../../../../layout/others/icon_star_half_yellow.svg";

const RatingItemPreview = (props) => {
  const startType = { empty: 0, half: 1, full: 2 };
  const starValue = 1;
  const numberOfStars = 5;
  const starsToRender = [];

  function calculateNumberOfStars() {
    for (let index = 0; index < numberOfStars; index += starValue) {
      let remainder = props.skill.rating - index;
      if (remainder >= starValue) {
        starsToRender.push(startType.full);
      } else if (remainder > 0 && remainder < starValue)
        starsToRender.push(startType.half);
      else {
        starsToRender.push(startType.empty);
      }
    }
  }

  calculateNumberOfStars();

  return starsToRender.map((star) => {
    if (star === startType.full)
      return (
        <span>
          <IconFullStar style={{ verticalAlign: "baseline" }} />
        </span>
      );
    else if (star === startType.half)
      return (
        <span>
          <IconHalfStar style={{ verticalAlign: "baseline" }} />
        </span>
      );
    else
      return (
        <span>
          <IconEmptyStar style={{ verticalAlign: "baseline" }} />
        </span>
      );
  });
};

export default RatingItemPreview;
